import { render, staticRenderFns } from "./order-send-import-dialog.vue?vue&type=template&id=5cba1988&"
import script from "./order-send-import-dialog.vue?vue&type=script&lang=js&"
export * from "./order-send-import-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports